import { createFileRoute } from '@tanstack/react-router'
import { AuditLogPanel } from '../components/platform/SettingsPanels.tsx'

export const Route = createFileRoute('/_authed/_shell/settings/audit-log')({
  component: AuditLogPanel,
})
